import { httpClient } from '@/services/http/httpClient'

export type StatusParticipation =
  | 'DEFAULT'
  | 'INVITED'
  | 'ACCEPTED'
  | 'REJECTED'
  | 'EXCLUDED'

export type UserInformationHttpResponse = {
  id: string
  name: string
  email: string
  image?: string
  area?: {
    id: string
    name: string
  }
  departament?: {
    id: string
    name: string
  }
  send_ideas: number
  participation_ideas_active: number
  participation_ideas: number
  ideas_finished: string
  status_idea_participation: StatusParticipation
}

export type UserInformation = {
  id: string
  name: string
  email: string
  image?: string
  area?: {
    id: string
    name: string
  }
  department?: {
    id: string
    name: string
  }
  sendIdeas: number
  participationIdeas: number
  activeParticipationIdeas: number
  finishedIdeasPercent: string
  statusIdeaParticipation: StatusParticipation
}

export async function getInformation(
  id: string,
  ideaId: string,
): Promise<UserInformation> {
  const { data } = await httpClient.get<UserInformationHttpResponse>(
    `/users/${id}/ideas/${ideaId}`,
  )

  const {
    id: userId,
    email,
    name,
    image,
    area,
    departament: department,
    send_ideas: sendIdeas,
    participation_ideas: participationIdeas,
    participation_ideas_active: activeParticipationIdeas,
    ideas_finished: finishedIdeasPercent,
    status_idea_participation: statusIdeaParticipation,
  } = data

  return {
    id: userId,
    email,
    name,
    image,
    area,
    department,
    sendIdeas,
    finishedIdeasPercent,
    activeParticipationIdeas,
    participationIdeas,
    statusIdeaParticipation,
  }
}
